<template>
    <div v-bind:class="{ 'd-none' : hidden }" class="fullscreen-container">
        <button class="btn btn--close" v-on:click="close()">x</button>
        <pinch-zoom>
            <img ref="pinchZoomImage" src="" alt="">
        </pinch-zoom>
    </div>
</template>

<script>

    export default {
        name: "FullscreenContainer",
        data: function ()
        {
            return {
                hidden: true,
            }
        },
        created()
        {
            this.$eventBus.$on('Fullscreen.show', (src) =>
            {
                this.$refs.pinchZoomImage.src = src;
                this.hidden = false;

                this.$tracking.actionClick('Fullscreen-Infobox-Image auf');
            });
        },
        methods: {
            close()
            {
                this.$refs.pinchZoomImage.src = '';
                this.hidden = true;

                this.$tracking.actionClick('Fullscreen-Infobox-Image zu');
            }
        }
    };
</script>


<style scoped lang="scss">

    @import "../assets/scss/functions";
    @import "../assets/scss/variables";
    @import "../assets/scss/mixins";

    .fullscreen-container {

        .btn--close {
            top: $header-height; //gridColumnsToRem(1);
            right: gridColumnsToRem(1);
            position: absolute;
            z-index: 1;
        }

        animation: fade-in-up $transition-default;
        animation-duration: 0.5s;
        animation-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000); /* easeOutExpo */

        pointer-events: auto;
        cursor: pointer;

        position: absolute;
        z-index: map_get($z-layers, fullscreen);
        top: -1 * $header-height;
        bottom: -1 * $footer-height;

        left: 0;
        width: 100%;

    }

</style>
